function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareHwp = function SvgShareHwp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0 0 36.985 0Z",
    style: {
      fill: "#e9e9e0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5.151V12h11.849L37.5.151Z",
    style: {
      fill: "#d9d7ca",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8",
      stroke: "#c8bdb8",
      strokeWidth: ".69px"
    },
    d: "M24.123 31.375h2.298v2.66h-2.298z",
    transform: "matrix(.95102 0 0 .78393 3.492 .672)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8",
      stroke: "#c8bdb8",
      strokeWidth: ".15px"
    },
    d: "M24.123 31.375h2.298v2.66h-2.298z",
    transform: "matrix(0 -.80697 5.46125 0 -151.112 49.1)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8",
      stroke: "#c8bdb8",
      strokeWidth: ".68px"
    },
    d: "M24.123 31.375h2.298v2.66h-2.298z",
    transform: "matrix(.96893 0 0 .78393 -3.288 18.195)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8",
      stroke: "#c8bdb8",
      strokeWidth: ".15px"
    },
    d: "M24.123 31.375h2.298v2.66h-2.298z",
    transform: "matrix(0 -.80697 5.56411 0 -154.49 66.589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.267 30.549c3.034 0 5.498 2.273 5.498 5.074 0 2.8-2.464 5.074-5.498 5.074-3.035 0-5.498-2.274-5.498-5.074 0-2.801 2.463-5.074 5.498-5.074Zm0 2.537c1.517 0 2.749 1.137 2.749 2.537s-1.232 2.537-2.749 2.537c-1.517 0-2.749-1.137-2.749-2.537s1.232-2.537 2.749-2.537Z",
    style: {
      fill: "#c8bdb8",
      stroke: "#c8bdb8",
      strokeWidth: ".68px"
    },
    transform: "matrix(.8521 0 0 .92366 3.405 2.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.061,
    cy: 43.911,
    r: 1.28,
    style: {
      fill: "#c8bdb8",
      stroke: "#c8bdb8",
      strokeWidth: ".6px"
    },
    transform: "translate(.599 -1.233)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ed6ec"
    },
    d: "M3.759 1.929h31.026v12.266H3.759z",
    transform: "matrix(1.04306 0 0 1.01149 -1.268 2.604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.791 16.821H6.5v5.037l-3.709-5.037Z",
    style: {
      fill: "#30b4cc"
    },
    transform: "translate(-.17 -.052) scale(1.01149)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "'ArialMT','Arial',sans-serif",
      fontSize: "9.336px",
      fill: "#fff"
    },
    transform: "translate(6.834 14.37) scale(1.08068)"
  }, "HWP"));
};
export default SvgShareHwp;